import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { useMutation } from "@tanstack/react-query";
import CashierApi from "../../utility/CashierApi";

function ChatDelete({ messageId }) {
  const { deleteData } = CashierApi();
  const DeleteMessage = useMutation({
    mutationFn: () => deleteData("chats/delete/", messageId),
    onSuccess: () => {
      // Automatically refetches the "cart" query, ensuring the data is correct
      // queryClient.invalidateQueries("notifications");
    },
  });

  const handleDelete = (id) => {
    DeleteMessage.mutate(id);
  };
  return (
    <div>
      <DeleteIcon
        className="text-red-500 cursor-pointer "
        onClick={() => handleDelete(messageId)}
      />
    </div>
  );
}

export default ChatDelete;
